export default __webpack_public_path__ + "static/events-light-mode-ba8c96b488538741fb550de5e49a330a.png";